export default ({ buttons: { menuButton, primary } }) => ({
  root: {
    display: 'inline-block',
    position: 'relative',
    margin: [10, 0]
  },
  dropdown: {
    fontFamily: menuButton.fontFamily,
    lineHeight: menuButton.lineHeight,
    background: menuButton.background,
    border: `1px solid ${menuButton.borderColor}`,
    borderRadius: menuButton.borderRadius,
    padding: menuButton.padding,
    position: 'relative'
  },
  dropdownButton: {
    fontSize: menuButton.fontSize,
    color: menuButton.fontColor,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: [4, 15, 0],
    marginRight: 35,
    '&:focus': {
      outline: primary.outlineReplacement ? 'none' : undefined,
      boxShadow: primary.outlineReplacement,
      borderRadius: [10, 0, 0, 10]
    }
  },
  dropdownToggle: {
    color: menuButton.fontColor,
    border: 'none',
    background: 'transparent',
    padding: [1, 6, 0, 6],
    marginTop: 2,
    right: 0,
    top: 0,
    position: 'absolute',
    borderLeft: `1px solid ${menuButton.dropdownToggleBorder}`,
    cursor: 'pointer',
    '&:focus': {
      outline: primary.outlineReplacement ? 'none' : undefined,
      boxShadow: primary.outlineReplacement,
      borderRadius: [0, 10, 10, 0]
    }
  },
  dropdownMenu: {
    display: 'block',
    width: '100%',
    position: 'absolute',
    top: menuButton.dropdownOffset,
    left: 0,
    padding: 0,
    margin: 0,
    listStyle: 'none',
    border: `1px solid ${menuButton.borderColor}`,
    borderRadius: menuButton.dropdownRadius,
    background: menuButton.dropdownBackground
  },
  dropdownMenuItem: {
    '&:hover': {
      backgroundColor: menuButton.dropdownMenuHover,
      borderRadius: menuButton.dropdownRadius
    },
    '&:first-child': {
      borderRadius: [menuButton.dropdownRadius, menuButton.dropdownRadius, 0, 0]
    },
    '&:last-child': {
      borderRadius: [0, 0, menuButton.dropdownRadius, menuButton.dropdownRadius]
    }
  },
  dropdownAction: {
    border: 'none',
    cursor: 'pointer',
    background: 'transparent',
    padding: [5, 14],
    textAlign: 'left',
    width: '100%',
    fontSize: menuButton.fontSize,
    fontFamily: menuButton.fontFamily,
    lineHeight: menuButton.lineHeight,
    color: menuButton.fontColor
  },
  icon: {
    height: 20,
    width: 20,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    top: 5,
    '& svg': {
      width: 16,
      height: 16,
      fill: menuButton.borderColor
    }
  }
});
